import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087750.svg";
import safeIcon from "@assets/icons/safeIcon.svg";
import { HeroSection } from "../../components";
import { CareersPage } from "@features/general";

export function Careers() {
  return (
    <CareersPage
      hero={
        <HeroSection
          title="Join a Company That Powers Safety, Innovation & Community"
          description="At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), our people are the foundation of our success. We are committed to hiring skilled professionals who share our values of safety, integrity, innovation, and customer service excellence."
          heroImage={heroImage}
          badgeIcon={<img src={safeIcon} alt="" className="w-7 h-7" />}
          cta={
            <button
              onClick={() => {
                document
                  .getElementById("job-openings")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="flex items-center gap-2.5 py-3 pl-4 pr-2 bg-[#090d2c] rounded-[40px] text-[20px] md:text-[24px] text-white font-albert-sans tracking-[-0.04em] hover:bg-[#1a1f3a] transition-colors"
            >
              View Open Positions
              <svg
                className="w-10 h-10 rounded-full bg-white/10 p-2"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          }
        />
      }
      footer={<Footer />}
    />
  );
}

export default Careers;
